export class CompanySelectorQueryModel {
    page: number;
    limit: number;
    search: string;
}

export class CompanySelectorListModel {
    page: number;
    totalItem: number;
    totalPage: number;
    itemList: Array<CompanySelectorModel>;
}

export class CompanySelectorModel {
    companySurrKey: number;
    companyName: string;
}